document.addEventListener('DOMContentLoaded', function () {
  var st = document.createElement('style');
  st.textContent =
    '.kwo-mobile-drawer__list [data-kwo-drawer-toggle] .caret{display:inline-block;padding:10px 14px;margin:-10px -14px -10px 0;cursor:pointer}' +
    '.kwo-header__navitem.has-mega .kwo-mega::before{content:"";position:absolute;left:0;right:0;top:-12px;height:12px}';
  document.head.appendChild(st);

  document.querySelectorAll('.kwo-header').forEach(function (header) {
    var THRESHOLD = 24;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = header.querySelector('[data-kwo-burger]');
    var closeBtn = header.querySelector('[data-kwo-drawer-close]');
    var overlay = header.querySelector('.kwo-mobile-drawer__overlay');
    function openDrawer() { header.classList.add('mobile-open'); }
    function closeDrawer() { header.classList.remove('mobile-open'); }
    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Mobiel menu: het pijltje klapt het submenu uit, de naam gaat naar de pagina.
    header.querySelectorAll('[data-kwo-drawer-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        if (!e.target.closest('.caret')) return;
        e.preventDefault();
        var parent = toggle.closest('[data-kwo-drawer-item]');
        if (parent) parent.classList.toggle('is-open');
      });
    });

    var cartToggle = header.querySelector('[data-kwo-cart-toggle]');
    if (cartToggle && window.eventBus) {
      cartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        window.eventBus.emit('open:cart:drawer');
      });
    }

    // Desktop: de link gaat gewoon naar de pagina, het menu opent bij hover.
    // Het menu blijft kort open nadat de muis het verlaat, zodat je niet per ongeluk
    // buiten het vlak valt. Op apparaten zonder hover opent de eerste tik het menu.
    var items = header.querySelectorAll('.kwo-header__navitem.has-mega');
    items.forEach(function (item) {
      var link = item.querySelector('.kwo-header__navlink');
      var timer = null;
      function closeOthers() {
        items.forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
      }
      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(timer);
        closeOthers();
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { item.classList.remove('is-open'); }, 300);
      });
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(max-width: 949px)').matches) return;
        if (window.matchMedia('(hover: hover)').matches) return;
        if (item.classList.contains('is-open')) return;
        e.preventDefault();
        closeOthers();
        item.classList.add('is-open');
      });
    });
  });
});
